/** Minimal typed event emitter */
export class EventEmitter<T extends { [K in keyof T]: (...args: any[]) => void }> {
  private listeners = new Map<keyof T, Set<Function>>();

  on<K extends keyof T>(event: K, cb: T[K]): void {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event)!.add(cb);
  }

  off<K extends keyof T>(event: K, cb: T[K]): void {
    this.listeners.get(event)?.delete(cb);
  }

  emit<K extends keyof T>(event: K, ...args: Parameters<T[K]>): void {
    this.listeners.get(event)?.forEach((cb) => {
      try { cb(...args); } catch (e) { console.error(`[Webphone] Event handler error (${String(event)}):`, e); }
    });
  }

  removeAll(): void {
    this.listeners.clear();
  }
}
